import { render, staticRenderFns } from "./Groupes.vue?vue&type=template&id=6fad390f&scoped=true"
import script from "./Groupes.vue?vue&type=script&lang=js"
export * from "./Groupes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad390f",
  null
  
)

export default component.exports